<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 8.09473L8.3908 14.1556V17.8525L5.00397 23.9014L5 8.09473Z"
          fill="#5B57A2"
    />
    <path d="M18.019 11.95L21.1963 10.0026L27.6989 9.99658L18.019 15.9265V11.95Z"
          fill="#D90751"
    />
    <path d="M18.0014 8.05896L18.0193 16.0833L14.6206 13.995V2L18.0014 8.05896Z"
          fill="#FAB718"
    />
    <path d="M27.6992 9.99656L21.1964 10.0026L18.0014 8.05896L14.6206 2L27.6992 9.99656Z"
          fill="#ED6F26"
    />
    <path d="M18.0193 23.935V20.0418L14.6206 17.9932L14.6225 30L18.0193 23.935Z"
          fill="#63B22F"
    />
    <path d="M21.1887 22.0053L8.39056 14.1556L5 8.09473L27.6853 21.9974L21.1887 22.0053Z"
          fill="#1487C9"
    />
    <path d="M14.6226 30.0002L18.019 23.9352L21.1883 22.0055L27.685 21.9976L14.6226 30.0002Z"
          fill="#017F36"
    />
    <path d="M5.00391 23.9013L14.6483 17.9933L11.4059 16.0039L8.39074 17.8524L5.00391 23.9013Z"
          fill="#984995"
    />
  </svg>
</template>
